import React, {useEffect, useState} from 'react';
import {getLanguage, t} from 'react-switch-lang';
import Modal from 'reactstrap/lib/Modal';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import './modal.scss';
import Toast from '../../../../components/toast/Toast';
import SelectInfinite from "../../../../components/FormFields/SelectInfinite";
import InputText from "../../../../components/FormFields/InputText";
import InputDate from "../../../../components/FormFields/inputDate/InputDate";
import {addCodebook, updateCodebook} from "../../../../services/IncurredEvent/incurredEventApi";
import {nanoid} from "nanoid";
import {
    formatNumberInput,
    parseFormattedNumber, maxDecimalNumber,
    formatNumberForDisplay, testIsGreaterThanMin,
    testValidNumber
} from "../../../../utils/helpers";
import {defaultMinValueZero} from "../../../../utils/const";
import TextArea from '../../../../components/FormFields/Textarea';

function LossModal({id, open, isOpen,setLossData,lossData, isEdit,riskId}) {
    const schema = yup.object().shape({
        lossReason: yup.object().nullable().required(t('message.fieldRequired')),
        netLoss: yup
            .string()
            .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
                return testIsGreaterThanMin(value,defaultMinValueZero);
            }).test('is-valid-number', t('message.mustBeNumber'), (value) => {
               return testValidNumber(value);
            })
            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                return maxDecimalNumber(value);
            })
            .required(t('message.fieldRequired')),
        lossDate: yup
            .string()
            .nullable()
            .required(t('message.fieldRequired')),
      descriptionLoss:   yup
        .string()
        .trim()
        .when([], {
          is: () => window.location.pathname.includes('court-risk'),
          then: yup
            .string()
            .required(t('message.fieldRequired'))
            .max(2048, t('message.max', {max: 2048})),
          otherwise: yup
            .string()
            .nullable()
            .max(2048, t('message.max', {max: 2048})),
        })
    });
    const [loading,setLoading] = useState(false);
    const [localEditData,setLocalEditData] = useState([]);
    const [isCalendarOpen,setIsCalendarOpen] = useState(false);

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, watch,setValue} = methods;
    const toggleShowModal = (e) => {
        e && e.preventDefault();
        isOpen(!open);
    };

    useEffect(() => {
      setLocalEditData(
        lossData.find((loss) => loss.id === id || loss.tempId === id)
      );
    },[id])

  const submitForm = (data) => {
    setLoading(true);

    const formattedLossDate = new Date(data?.lossDate).toISOString().split('.')[0];

    if (isEdit) {
      setLossData(prev =>
        prev.map(item =>
          (item?.id && item.id === localEditData?.id) ||
          (item?.tempId && item.tempId === localEditData?.tempId)
            ? {
              ...item,
              lossReason: data?.lossReason,
              netLoss: data?.netLoss,
              lossDate: formattedLossDate,
              description: data?.descriptionLoss
            }
            : item
        )
      );

      // Toast.fire({
      //   title: t('codebook.successfullyEditedCodeBook'),
      //   icon: 'success',
      // });
    } else {
      setLossData(prev => [
        ...prev,
        {
          tempId: nanoid(),
          id: null,
          lossReason: data?.lossReason,
          netLoss: data?.netLoss,
          lossDate: formattedLossDate,
          description: data?.descriptionLoss,
        }
      ]);

      // Toast.fire({
      //   title: t('codebook.successfullyAddedCodeBook'),
      //   icon: 'success',
      // });
    }

    isOpen(false);
    setLoading(false);
  };
    // const submitForm = async (data) => {
    //     setLoading(true);
    //     if(isEdit) {
    //         if(riskId) {
    //             const netLossNumber = parseFormattedNumber(data.netLoss);
    //             updateCodebook({...data,
    //               netLoss: netLossNumber,
    //               id:localEditData?.id,
    //               lossDate: new Date(data.lossDate).toISOString().split('.')[0],
    //               ...(window.location.pathname.includes('court-risk')
    //                 ? { courtRiskId: riskId }
    //                 : { riskId: riskId }),
    //                 lossReason: {name: data.lossReason.label,id: data.lossReason.value}},localEditData?.id).then((res) => {
    //                     if(res.status >= 200 && res.status <= 299) {
    //                         setLocalEditData({...localEditData,lossReason: data.lossReason,netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0]});
    //                         setLossData(prev => prev.map(item =>
    //                             item.id === localEditData.id ? { ...item, lossReason: data.lossReason, netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0] } : item
    //                         ));
    //                         Toast.fire({
    //                             title: t('codebook.successfullyEditedCodeBook'),
    //                             icon: 'success',
    //                         });
    //                     }else {
    //                         Toast.fire({
    //                             title: t('codebook.updateError'),
    //                             icon: 'error',
    //                         });
    //                     }
    //             })
    //         }else {
    //             setLocalEditData({...localEditData,lossReason: data.lossReason,netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0]});
    //             setLossData(prev => prev.map(item =>
    //                 item.id === localEditData.id ? { ...item, lossReason: data.lossReason, netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0] } : item
    //             ));
    //             Toast.fire({
    //                 title: t('codebook.successfullyEditedCodeBook'),
    //                 icon: 'success',
    //             });
    //         }
    //     }else {
    //         if(riskId) {
    //             const netLossNumber = parseFormattedNumber(data.netLoss);
    //
    //             addCodebook({...data,
    //               netLoss: netLossNumber,
    //               lossDate: new Date(data.lossDate).toISOString().split('.')[0],
    //               ...(window.location.pathname.includes('court-risk')
    //                 ? { courtRiskId: riskId }
    //                 : { riskId: riskId }),
    //               lossReason: {lossReason: data.lossReason.label,id: data.lossReason.value}})
    //               .then((res) => {
    //               if(res.status === 200) {
    //                   const lossDate = new Date(data.lossDate);
    //                   lossDate.setHours(12, 0, 0, 0)
    //                   setLossData((prev) => [
    //                       ...prev,
    //                       {
    //                           id: res.data.id,
    //                           lossReason: data.lossReason,
    //                           netLoss: data.netLoss,
    //                           lossDate: lossDate.toISOString().split('.')[0],
    //                       }
    //                   ]);
    //                   Toast.fire({
    //                       title: t('codebook.successfullyAddedCodeBook'),
    //                       icon: 'success',
    //                   });
    //               }else {
    //                   Toast.fire({
    //                       title: t('codebook.addError'),
    //                       icon: 'error',
    //                   });
    //               }
    //           })
    //         }else {
    //             const lossDate = new Date(data.lossDate);
    //             const netLossNumber = parseFormattedNumber(data.netLoss);
    //
    //             lossDate.setHours(12, 0, 0, 0)
    //             setLossData((prev) => [...prev,{lossReason: data.lossReason,netLoss: data.netLoss,id: nanoid(),
    //                 lossDate: lossDate.toISOString().split('.')[0]}]);
    //             Toast.fire({
    //                 title: t('codebook.successfullyAddedCodeBook'),
    //                 icon: 'success',
    //             });
    //         }
    //     }
    //     isOpen(false)
    //     setTimeout(() => {
    //         setLoading(false)
    //     },500)
    // };


    const handleChange = (event) => {
        event.target.value = formatNumberInput(event.target.value);
    };

    return (
        <>
            <Modal isOpen={open} className={`modal-sm verify-modal ${isCalendarOpen && 'calendarOpened'}`}>
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(submitForm)}>
                        <div className="close-img">
                            <img
                                src="/images/exclusion.svg"
                                alt="Exclusion"
                                onClick={(e) => toggleShowModal(e)}
                                style={{cursor: 'pointer'}}
                            />
                        </div>
                        <div className="modal-header history-header">
                            {isEdit ? t('codebook.codebookEdit') : t('codebook.codebookAdd')}
                        </div>
                        <label className="label-incurred mt-2">
                            {t('codebook.addCodebook')}
                        </label>
                        <SelectInfinite
                            api="/loss-reasons"
                            name="lossReason"
                            placeholder={t('codebook.codebookPlaceholder')}
                            labelKey={getLanguage() === 'mne' ? 'name' : 'nameEn'}
                            className="loss-modal-select"
                            isClearable
                            defaultValue={isEdit && localEditData?.lossReason}
                        />
                        <label className="label-incurred mt-2">
                            {window.location.pathname.includes('court-risk') ? t('codebook.paymentAmount') : t('codebook.loss')}
                        </label>
                        <InputText
                            type="text"
                            name="netLoss"
                            onChange={handleChange}
                            className="form-control input-field"
                            placeholder={window.location.pathname.includes('court-risk') ? t('codebook.paymentAmountPlaceholder') : t('codebook.lossPlaceholder')}
                            id="title"
                            defaultValue={isEdit && localEditData?.netLoss ? formatNumberInput(formatNumberForDisplay(localEditData?.netLoss)) : ''}
                        />
                        <label className="label-incurred mt-2">
                            {window.location.pathname.includes('court-risk') ? t('codebook.paymentDate') : t('codebook.lossDate')}
                        </label>
                        <InputDate
                            name="lossDate"
                            defaultValue={isEdit && new Date(localEditData?.lossDate)}
                            placeholder={window.location.pathname.includes('court-risk') ? t('codebook.paymentDatePlaceholder') : t('codebook.lossDatePlaceholder')}
                            style={{height: '65px!important'}}
                            forceSelected={true}
                            onCalendarOpen={() => setIsCalendarOpen(true)}
                            onCalendarClose={() => setIsCalendarOpen(false)}
                            isClearable={true}
                        />
                      {window.location.pathname.includes('court-risk') ? <>
                      <label className="label-incurred mt-2">
                        {t('codebook.descriptionLoss')}
                      </label>
                      <TextArea
                        name="descriptionLoss"
                        placeholder={t('codebook.descriptionLossPlaceholder')}
                        defaultValue={isEdit && localEditData?.description ? localEditData?.description : ''}
                      />
                      </> : null}
                        <div className="modal-footer history-footer">
                            <button type={'button'} disabled={loading} className="secondary-btn" onClick={() => isOpen(false)}>
                                {t('codebook.revert')}
                            </button>
                            <button type={'button'} disabled={loading}  className="primary-btn"
                                    onClick={handleSubmit(submitForm)}>
                                {isEdit ? t('codebook.edit') : t('codebook.add')}
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default LossModal;
